var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper d-flex h-100" },
    [
      _vm.upgrade.enabled && _vm.upgrade.type === "modal"
        ? _c("UpgradeNeeded", {
            attrs: { plan: _vm.upgrade.plan },
            on: { close: _vm.upgradeModalClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: { "mobile-contents": _vm.isMobile },
          attrs: { id: "contents" },
        },
        [
          _vm.isNotifyShowing && !_vm.isAdmin && !_vm.notifyIgnored && false
            ? _c("NotificationPermissionAlert", {
                on: {
                  close: function ($event) {
                    _vm.isNotifyShowing = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("Header"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c("Sidebar"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content-view",
                  class: {
                    "menu-active": _vm.menu.isOpen || _vm.menu.hoverActive,
                  },
                },
                [
                  _vm.upgrade.enabled && _vm.upgrade.type === "overlay"
                    ? _c("UpgradeNeededPageOverlay", {
                        attrs: {
                          plan: _vm.upgrade.plan,
                          feature: _vm.upgrade.feature,
                          name: _vm.upgrade.name,
                        },
                      })
                    : [
                        _vm.upgrade.enabled &&
                        _vm.upgrade.type === "overlay-limited"
                          ? _c("UpgradeNeededPageOverlay", {
                              attrs: {
                                plan: _vm.upgrade.plan,
                                feature: _vm.upgrade.feature,
                                name: _vm.upgrade.name,
                                limited: true,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("router-view", {
                          staticClass: "content-view-child",
                        }),
                      ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }